import moment from 'moment';
import 'moment-timezone';

import { INIT } from './app';

const reducer = (state = [], action) => {
  switch (action.type) {
    case INIT: {
      const incoming = Array.isArray(action.payload && action.payload.timezoneList)
        ? action.payload.timezoneList
        : [];
      if (incoming.length === 0 && state && Array.isArray(state.list) && state.list.length > 0) {
        return state;
      }
      return {
        list: [...incoming],
        current: incoming.find(timezone => timezone.name === moment.tz.guess()),
      };
    }
    default:
      return state;
  }
};

export default reducer;
